import Swiper from 'swiper';

const videoSliderContainer = document.querySelector('.bim-videos-slider-container');
const gallerySliderContainer = document.querySelector('.bim-gallery-slider-container');
const homepageSliderContainer = document.querySelector('.homepage-slider-container');

if(videoSliderContainer){

    var swiper = new Swiper(videoSliderContainer, {

        navigation: {
          nextEl: videoSliderContainer.parentElement.querySelector('.swiper-button-next'),
          prevEl: videoSliderContainer.parentElement.querySelector('.swiper-button-prev'),
        },
        pagination: {
            el: videoSliderContainer.parentElement.querySelector('.swiper-pagination'),
            type: 'progressbar',
        },
    });

}

if(gallerySliderContainer){

    var swiper = new Swiper(gallerySliderContainer, {

        navigation: {
          nextEl: gallerySliderContainer.parentElement.querySelector('.swiper-button-next'),
          prevEl: gallerySliderContainer.parentElement.querySelector('.swiper-button-prev'),
        },
        pagination: {
            el: gallerySliderContainer.parentElement.querySelector('.swiper-pagination'),
            type: 'progressbar',
        },
    });

}

if(homepageSliderContainer){

    var swiper = new Swiper(homepageSliderContainer, {

        navigation: {
          nextEl: homepageSliderContainer.querySelector('.swiper-button-next'),
          prevEl: homepageSliderContainer.querySelector('.swiper-button-prev'),
        },
//        pagination: {
//            el: homepageSliderContainer.querySelector('.swiper-pagination'),
//            type: 'progressbar',
//        },
    });

}


// WEBPACK FOOTER //
// ./assets/js/src/modules/sliders.js